import React, {useMemo} from "react";
import {
    MAIN_TAB, ORDER_TYPES, PAYMENT_METHODS, preserveSearchParams,
    SUB_TAB
} from "@icoach/batchPayment/staticData";
import {
    DebitListForACH,
    DebitListForCash,
    DebitListForCreditCard,
    DebitListSwitcher
} from "@icoach/batchPayment/component";
import {useBatchPaymentContext} from "@icoach/batchPayment/component/BatchPaymentContext";
import {Link} from 'react-router-dom';
import {mergeQueryToUrl} from '@util/utils';
import {ACCOUNT_BOOK_BULK_DEBIT_URL} from '@icoach/router/routerPath';

/** ================================
 * 📌 會籍月費逾期扣款名單
 *  ================================
 */
const MembershipBatchPaymentOverdueDebitList = () => {
    const {searchParams, batchPaymentLists, dialogRef, getBatchPayments} = useBatchPaymentContext();

    const paymentMethodActions = useMemo(() => {
            const {creditUnpaidItems, achUnpaidItems, cashUnpaidItems} = batchPaymentLists || {};
            return {
                [PAYMENT_METHODS.CREDIT]: {
                    label: "信用卡",
                    value: PAYMENT_METHODS.CREDIT,
                    buttonComponent: Link,
                    to: mergeQueryToUrl(ACCOUNT_BOOK_BULK_DEBIT_URL, preserveSearchParams(searchParams, {
                        [MAIN_TAB]: ORDER_TYPES.OVERDUE,
                        [SUB_TAB]: PAYMENT_METHODS.CREDIT
                    })),
                    debitListComponent: <DebitListForCreditCard sourceData={batchPaymentLists}
                                                                searchParams={searchParams} dialogRef={dialogRef}
                                                                refresh={getBatchPayments}/>,
                    listData: creditUnpaidItems || []
                },
                [PAYMENT_METHODS.ACH]: {
                    label: "ACH",
                    value: PAYMENT_METHODS.ACH,
                    to: mergeQueryToUrl(ACCOUNT_BOOK_BULK_DEBIT_URL, preserveSearchParams(searchParams, {
                        [MAIN_TAB]: ORDER_TYPES.OVERDUE,
                        [SUB_TAB]: PAYMENT_METHODS.ACH
                    })),
                    buttonComponent: Link,
                    debitListComponent: <DebitListForACH sourceData={batchPaymentLists} searchParams={searchParams}
                                                         dialogRef={dialogRef} refresh={getBatchPayments}/>,
                    listData: achUnpaidItems || []
                },
                [PAYMENT_METHODS.CASH]: {
                    label: "現金",
                    value: PAYMENT_METHODS.CASH,
                    to: mergeQueryToUrl(ACCOUNT_BOOK_BULK_DEBIT_URL, preserveSearchParams(searchParams, {
                        [MAIN_TAB]: ORDER_TYPES.OVERDUE,
                        [SUB_TAB]: PAYMENT_METHODS.CASH
                    })),
                    buttonComponent: Link,
                    debitListComponent: <DebitListForCash sourceData={batchPaymentLists} searchParams={searchParams}
                                                          dialogRef={dialogRef} refresh={getBatchPayments}/>,
                    listData: cashUnpaidItems || []
                }
            };
        },
        // eslint-disable-next-line
        [searchParams, batchPaymentLists, getBatchPayments]);

    return <DebitListSwitcher sourceData={paymentMethodActions}
                              currentPaymentMethod={searchParams[SUB_TAB]}/>;
};

export default MembershipBatchPaymentOverdueDebitList;